import React from 'react';
import useSeoForPage from '../hooks/useSeoForPage';

export default function ProviderPage() {
  useSeoForPage('/fuer-provider');
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl font-semibold text-slate-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
        Für Provider
      </h1>
      <p className="text-slate-600 leading-relaxed mb-8">
        Sie sind Domain-Provider und möchten Ihre Domains hier gelistet sehen? Gerne! Wir vergleichen Ihre Preise
        automatisch mit allen anderen Anbietern – und zeigen Ihren Kunden, wo Sie am günstigsten sind.
      </p>

      <div className="space-y-5 text-slate-600 leading-relaxed text-[15px]">
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Wie Sie als Provider gelistet werden
          </h2>
          <p>
            Ihre Preise werden regelmäßig automatisch von Ihrer öffentlichen Preisseite erfasst und in unseren
            Vergleich übernommen. So sind Sie von Anfang an dabei – ohne Aufwand.
          </p>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Ihr Vorteil: Werden Sie Pro-Partner
          </h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Ihr Logo, Ihre Beschreibung und Ihre Website-Links werden im Vergleich angezeigt</li>
            <li>Sie präsentieren eigene Angebote und Gutscheine direkt bei Ihren Preisen</li>
            <li>Ihre Preise werden täglich aktualisiert (statt nur alle paar Tage)</li>
            <li>Sie liefern Ihre Preise direkt per API oder JSON-Feed – keine manuelle Pflege nötig</li>
            <li>Ihr Profil erhält eine „Verifizierter Anbieter"-Kennzeichnung</li>
          </ul>
          <p className="mt-3">
            Die Freischaltung erfolgt per Jahresvertrag auf Rechnung. <a href="/kontakt" className="text-sky-600 hover:text-sky-700">Kontaktieren Sie uns</a> –
            wir erstellen Ihnen gerne ein Angebot.
          </p>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <h2 className="text-lg font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Technische Anbindung (Pro-Partner)
          </h2>
          <p>
            Für die tägliche Aktualisierung gibt es zwei Wege, beide liefern Preise im JSON-Format:
          </p>
          <ul className="list-disc pl-5 space-y-1.5 mt-2">
            <li>
              <strong>Polling:</strong> Sie stellen eine JSON-Datei mit Ihren Preisen bereit (z. B. unter
              <code className="text-sky-700 bg-sky-50 px-1 rounded"> https://ihre-domain.de/preise.json </code>)
              und wir lesen sie regelmäßig ab.
            </li>
            <li>
              <strong>Push-API:</strong> Sie senden Ihre Preise aktiv an unsere API (mit Ihrem persönlichen
              API-Key) – z. B. direkt nach jeder Preisänderung.
            </li>
          </ul>
          <p className="mt-3 text-sm text-slate-500">
            Für WHMCS-Betreiber stellen wir gerne ein fertiges Export-Script bereit.
          </p>
        </div>
      </div>
    </div>
  );
}
